/** @jsxRuntime classic */
// @ts-check
/** @jsx jsx */
import { gql } from '@apollo/client';
import { Col, P, Row, Text } from '@bottlebooks/gatsby-design-system';
import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import Section from '../Section/Section';
import SectionTitle from '../Section/SectionTitle';

const analyticFormat = {
  minimumFractionDigits: 1,
  maximumFractionDigits: 2,
};

export default function ProductAnalytics({ product, ...rest }) {
  const { i18n } = useLingui();
  if (!product) return null;
  const { alcohol, residualSugar, totalAcidity, designation } = product;
  // We don't display 'no' values at all, so we don't need to check for false vs. null.
  if (!alcohol && !residualSugar && !totalAcidity && !designation) return null;
  return (
    <Section {...rest}>
      <Row>
        {alcohol != null && (
          <Col sx={{ width: [null, '50%'] }}>
            <SectionTitle>
              <Trans>Alcohol</Trans>
            </SectionTitle>
            <P variant="title">{i18n.number(alcohol, analyticFormat)}%</P>
          </Col>
        )}
        {(residualSugar != null ||
          totalAcidity != null ||
          designation != null) && (
          <Col sx={{ width: [null, '50%'] }}>
            <SectionTitle>
              <Trans>Analytical data</Trans>
            </SectionTitle>
            {designation && <P variant="title">{designation}</P>}
            {residualSugar != null && (
              <Text>
                <Trans>
                  {i18n.number(residualSugar, analyticFormat)} g/l residual
                  sugar
                </Trans>
              </Text>
            )}
            {totalAcidity != null && (
              <Text>
                <Trans>
                  {i18n.number(totalAcidity, analyticFormat)} g/l acidity
                </Trans>
              </Text>
            )}
          </Col>
        )}
      </Row>
    </Section>
  );
}

export const fragment = graphql`
  fragment ProductAnalytics on Product {
    alcohol
    residualSugar
    totalAcidity
    designation
  }
`;

ProductAnalytics.fragment = gql`
  fragment ProductAnalytics on Product {
    alcohol
    residualSugar
    totalAcidity
    ... on Wine {
      designation
    }
  }
`;
